import { useMemo } from "react";
/**
 * Returns an object of URL query parameters.
 * @returns {object} Object of URL query parameters.
 */
export const useURLParams = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const params = Object.fromEntries(urlParams.entries());

  const parseUrlParams = useMemo(() => ({ ...params }), [params]);

  return parseUrlParams;
};
